import { useEffect, useState } from 'react'
import { getStripeConnection, type ConnectStatus } from '../../../lib/api'
import { useI18n } from '../../../lib/i18n'
import { StripeMark } from './StripeMark'
import { StripeAccountManagement } from './StripeAccountManagement'
import { StripeTaxSettings } from './StripeTaxSettings'
import { isEmbeddedStripeConfigured } from './StripeEmbed'

/**
 * Los datos del negocio que guarda Stripe —nombre legal, banco, impuestos—,
 * para enseñarlos fuera de Ajustes › Stripe.
 *
 * Vivían sólo allí, y quien busca «dónde cambio mi banco» o «mis datos
 * fiscales» va a Datos del negocio o a Región y moneda, no a una integración.
 * Son las mismas filas de la pantalla de Stripe (`StripeAccountManagement` y
 * `StripeTaxSettings`), no una copia: lo que cambie allí cambia aquí.
 *
 * Consulta la cuenta por su cuenta y no pinta nada hasta saberla: sin cuenta
 * —o sin permiso para verla, que el servidor contesta con error— esos enlaces
 * no llevarían a ninguna parte, así que no aparecen.
 */
export function StripeAccountRows({ projectId, token }: { projectId: string; token: string }) {
  const { t } = useI18n()
  const [status, setStatus] = useState<ConnectStatus | null>(null)

  useEffect(() => {
    let alive = true
    getStripeConnection(projectId, token)
      .then((connection) => { if (alive) setStatus(connection.status) })
      .catch(() => { /* sin cuenta que enseñar */ })
    return () => { alive = false }
  }, [projectId, token])

  if (status === null || status === 'none') return null

  return (
    <StripeAccountManagement
      icon={<StripeMark size={20} color="#635BFF" />}
      title={t('config.stripeRows')}
    >
      {isEmbeddedStripeConfigured() ? <StripeTaxSettings projectId={projectId} token={token} /> : null}
    </StripeAccountManagement>
  )
}
